import { Box, Button } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const CurrencyModalPreview = ({ data, currencyOption, defaults ,noEdit}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div>
      {" "}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { md: "90%", xs: "90%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          overflow: "auto",
          maxHeight: "95%",
          maxWidth: "400px",
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="border-b border-solid border-[#bbcfec] pb-4">
            <h2 className="text-sm font-bold">{data?.chTitle}</h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">عنوان ارسالی : </span>
            <h2 className="text-sm font-bold">{data?.chSellerStuffSendName}</h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">تعداد : </span>
            <h2 className="text-sm font-bold">{data?.flAmount} {data?.chMeasurementUnitName}</h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">میزان ارز : </span>
            <h2 className="text-sm font-bold">{data?.flCurrencyAmount} </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">نوع ارز : </span>
            <h2 className="text-sm font-bold">
              {data?.chCurrencyTypeName
                ? data?.chCurrencyTypeName
                : currencyOption?.find(
                    (item) =>
                      item?.guidRecNo === defaults?.guidCurrencyTypeRecNo
                  )?.chName}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm "> نرخ برابری ارز با ریال : </span>
            <h2 className="text-sm font-bold">
              {data?.moCurrencyExchangePrice?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm "> کارمزد فروش ارزش : </span>
            <h2 className="text-sm font-bold">
              {data?.moCurrencyWage?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
 
          <div className="flex items-center gap-2">
            <span className="text-sm ">مبلغ تخفیف : </span>
            <h2 className="text-sm font-bold">{data?.moDiscount?.toLocaleString("en-US")} ریال </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">نرخ ارزش افزوده :</span>
            <h2 className="text-sm font-bold">
              {data?.flValueAddedPercent} %{" "}
            </h2>
          </div>
        </div>
        <div className="flex col-span-2 justify-center items-center mt-5">
          <Button
            onClick={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
            }}
            sx={{ width: "8rem", background: "#ccc" }}
            variant="contained"
            color="inherit"
          >
            بازگشت
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default CurrencyModalPreview;
